import { useEffect, useState } from 'react';
import { endpoints } from '../services/api';

// Module-level cache so each article page is asked for its picture at most once per session.
const cache = new Map<string, Promise<string | null>>();

/**
 * The story's own picture, or – for feeds without images – the article page's preview
 * picture (og:image), looked up on demand through the server.
 */
export function usePreviewImage(image: string | null | undefined, link: string | null | undefined): string | null {
  const [found, setFound] = useState<string | null>(image ?? null);

  useEffect(() => {
    if (image) {
      setFound(image);
      return;
    }
    setFound(null);
    if (!link) return;
    let cancelled = false;
    let p = cache.get(link);
    if (!p) {
      p = endpoints
        .preview(link)
        .then((r) => r.image)
        .catch(() => null);
      cache.set(link, p);
    }
    void p.then((url) => !cancelled && setFound(url));
    return () => {
      cancelled = true;
    };
  }, [image, link]);

  return found;
}
